exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".auth .row{display:flex;flex-direction:row}.auth .row .content{flex:2}.auth .row .screenshot{flex:1;display:flex;flex-direction:column;justify-content:flex-start}.login,.register{padding-left:10px;margin:0 auto;display:flex;flex-direction:column}.login form,.register form{width:400px;max-width:90%}.login a,.register a{margin-top:20px}\n", ""]);

